import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthPayloadTicket, AuthorizationData } from '@zero/shared/util-models';
import { Checklist } from '../../entities/checklist.entity';
import { terminateDepotActions, terminateDepotApiActions } from './terminate-depot.actions';

export interface TerminateDepotState {
  loading: boolean;
  checklist: Checklist;
  isReady: boolean;
  dataToAuthorize: AuthorizationData<AuthPayloadTicket> | null;
  authSuccess: boolean;
  terminationDone: boolean;
  hasError: boolean;
}

export const initialTerminateDepotState: TerminateDepotState = {
  loading: false,
  checklist: undefined,
  isReady: false,
  authSuccess: false,
  terminationDone: false,
  hasError: false,
  dataToAuthorize: null,
};

export const terminateDepotFeature = createFeature({
  name: 'terminateDepot',
  reducer: createReducer(
    initialTerminateDepotState,
    on(terminateDepotActions.loadChecklistState, (state): TerminateDepotState => ({ ...state, loading: true })),
    on(
      terminateDepotApiActions.loadChecklistStateSuccess,
      (state, { checklist }): TerminateDepotState => ({
        ...state,
        checklist,
        loading: false,
        isReady: checklist.valid,
      }),
    ),
    on(terminateDepotApiActions.loadChecklistStateFailure, (state): TerminateDepotState => ({ ...state, loading: false, isReady: false })),
    on(terminateDepotActions.terminate, (state): TerminateDepotState => ({ ...state, authSuccess: false, dataToAuthorize: null })),
    on(terminateDepotActions.setDataToAuthorize, (state, { dataToAuthorize }): TerminateDepotState => ({ ...state, dataToAuthorize })),
    on(terminateDepotActions.handleAuthenticationResult, (state, { result }): TerminateDepotState => {
      if (result.success) {
        return { ...state, dataToAuthorize: null, authSuccess: result.success };
      }

      if (result.reason === 'CanceledByUser') {
        return { ...state, dataToAuthorize: null };
      }

      return { ...state };
    }),
    on(terminateDepotActions.setError, (state, { error }): TerminateDepotState => ({ ...state, hasError: error })),
    on(
      terminateDepotApiActions.terminatedSuccess,
      (state, { terminationDone }): TerminateDepotState => ({ ...state, terminationDone, loading: !terminationDone }),
    ),
    on(terminateDepotApiActions.terminatedFailure, (state): TerminateDepotState => ({ ...state, loading: false })),
  ),
});
